module.exports = __webpack_public_path__ + "static/media/PaperIcon.3f9762f5.png";